export default __webpack_public_path__ + "static/media/a011-market-6.97a77291.svg";